import { render, staticRenderFns } from "./GoDigital.vue?vue&type=template&id=1e58d464&"
import script from "./GoDigital.vue?vue&type=script&lang=js&"
export * from "./GoDigital.vue?vue&type=script&lang=js&"
import style0 from "./GoDigital.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports